import { render, staticRenderFns } from "./OrgTable.vue?vue&type=template&id=1b071624&scoped=true"
import script from "./OrgTable.vue?vue&type=script&lang=js"
export * from "./OrgTable.vue?vue&type=script&lang=js"
import style0 from "./OrgTable.vue?vue&type=style&index=0&id=1b071624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b071624",
  null
  
)

export default component.exports